import styled, { css } from "styled-components";

const FlyoutStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;

  .flyoutInner {
    opacity: 0;
    transition: transform 1s;
    position: relative;
    padding: ${(props) => (props.padding ? props.padding : "2.4rem")};
    background-color: ${(props) => props.theme.white};
    width: 100%;
    height: 100%;
    overflow-y: auto;

    > div {
      margin-top: 6rem;
    }

		@media only screen and (min-width: ${props => props.theme.tablet}) {
      width: 57rem;
      height: 100%;
      transform: translateX(100%);
    }
  }

  ${(props) => {
    return (
      props.open &&
      css`
        visibility: visible;
        opacity: 1;

        .flyoutInner {
          transition: transform 1s;
          opacity: 1;
          transform: translateX(0);
          overflow-y: auto;
        }
			`
		);
	}}

  .closeBn {
    position: absolute;
    right: 3rem;
    top: 4rem;
		color: ${props => props.theme.lightGreen};
		font-family: ${props => props.theme.fontBold};

    svg {
      margin-right: 1rem;
    }
  }

  h2 {
    width: 90%;
  }
`;

export default FlyoutStyled;
